////////////////////////////////////////////
// ENTRY POINT — MOUNTS THE APP
////////////////////////////////////////////
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";
import { armMwa } from "@/lib/wallet/mwa";
import { captureDeeplinkReturn } from "@/lib/wallet/deeplink/resume";
import * as log from "@/lib/log";
import "@/styles/theme.css";

// ARM LOGGING FIRST — THE FETCH PATCH + ERROR HANDLERS MUST EXIST BEFORE
// ANY MODULE ISSUES A REQUEST (SAME ORDER THE VANILLA SCRIPT CHAIN ENFORCED)
log.arm();

// WALLET-APP RETURN TRIP — STASH + SCRUB THE DEEPLINK RESPONSE PARAMS BEFORE
// THE ROUTER EVER READS THE URL (AuthProvider FINISHES THE FLOW ONCE MOUNTED)
captureDeeplinkReturn();

// REGISTER THE SOLANA MOBILE WALLET ADAPTER — MAKES ANDROID CONNECT WORK IN A
// NORMAL BROWSER TAB (NO-OP OFF-ANDROID/OFF-HTTPS, SO DESKTOP + iOS UNCHANGED)
armMwa();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
